import { render } from "./createTeam.vue?vue&type=template&id=c4cd18fa&scoped=true"
import script from "./createTeam.vue?vue&type=script&lang=js"
export * from "./createTeam.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./createTeam.vue?vue&type=style&index=1&id=c4cd18fa&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4cd18fa"]])

export default __exports__